export default __webpack_public_path__ + "static/media/photo5.853c72e2.jpg";